// Brand Configuration System
// This file defines the configuration for all supported brands in the application

export const BRAND_IDS = {
  CLAIM1: "CLAIM1",
  YCM: "YCM",
  MLM: "MLM",
};

// MLM Variation Configuration - Hardcoded to use variation 2
export const MLM_ACTIVE_VARIATION = 2; // Change this to 1 or 2 to switch variations

export const BRANDS = {
  [BRAND_IDS.CLAIM1]: {
    id: BRAND_IDS.CLAIM1,
    name: "Claims1",
    displayName: "Claims1",
    domains: ["app.claims1.co.uk", "claims1.co.uk", "localhost"],
    email: "info@claims1.co.uk",
    supportEmail: "support.email@claims1.co.uk",

    reviewUrls: {
      customerReview: "https://claims1.co.uk/customer-review",
      google: "https://g.page/r/CY-5KuABk17iEAI/review",
      trustpilot: "https://www.trustpilot.com/evaluate/claims1.co.uk",
    },

    // Probability for "Good" and "Excellent" ratings to route to Google vs Trustpilot
    reviewProbabilities: {
      google: 0.5, // 50% chance to use Google
      trustpilot: 0.5, // 50% chance to use Trustpilot
    },

    colors: {
      primary: "#000000",
      secondary: "#00B3B3",
      accent: "#ff914d",
      brandColor: "#ff914d",
      currentColor: "#000000",
      altFontColor: "#000000",
      grayBg: "rgba(99, 136, 198, 0.05)",
      lightGrayBg: "#F7F7F7",
      extraLightGrayBg: "#F3F4F4",
      grayColor: "#171717",
      borderColor: "#dddddd",
      pinkColor: "#FEF3EF",
      disabledColor: "#BFCDCD",
      infoBoxBg: "#c3dfe0",
      infoBoxText: "#042020",
      alertBoxBg: "#002020",
      lenderBlockBg: "#cbf2f9",
      successColor: "#008F8F",
      darkBg: "#001A42",
      inputBorder: "#707070",
      lightBorder: "#ccc",
      whiteBg: "#ffffff",
      offWhiteBg: "#fff",
      lightGrayBorder: "#ddd",
      mediumGray: "#999",
      darkGray: "#666",
      textDark: "#333",
      hoverGray: "#f5f5f5",
    },

    logo: "/logos/claims1-logo.svg",
    favicon: "/logos/claims1-favicon.svg",
    font: "'Raleway', sans-serif",
    rating: 4.5,

    meta: {
      title: "Claims1 - Car Finance Claims",
      description: "Make your car finance claim with Claims1",
    },
  },

  [BRAND_IDS.YCM]: {
    id: BRAND_IDS.YCM,
    name: "YCM",
    displayName: "Your Claim Matters",
    domains: ["app.ycmcarfinanceclaims.co.uk", "ycmcarfinanceclaims.co.uk"],
    email: "info@yourclaimmatters.co.uk",
    supportEmail: "support.email@yourclaimmatters.co.uk",

    reviewUrls: {
      customerReview: "https://www.yourclaimmatters.co.uk/customer-review",
      google: "https://g.page/r/CS9KenVF2ixsEAI/review",
      trustpilot: "https://www.trustpilot.com/evaluate/yourclaimmatters.co.uk",
    },

    // Probability for "Good" and "Excellent" ratings to route to Google vs Trustpilot
    reviewProbabilities: {
      google: 0.5, // 50% chance to use Google
      trustpilot: 0.5, // 50% chance to use Trustpilot
    },

    colors: {
      primary: "#0d86bc", // Main blue brand color (rgb(13, 134, 188))
      secondary: "#ff914d", // Orange for hover state
      accent: "#0d86bc", // Blue accent for normal button state
      brandColor: "#0d86bc", // Primary brand color
      currentColor: "#000000", // Black (main text)
      altFontColor: "#ffffff", // White text
      grayBg: "rgba(255, 145, 77, 0.05)", // Light orange tint
      lightGrayBg: "#FAFBFC", // Off-white background
      extraLightGrayBg: "#f2f5f7", // Light grayish background
      grayColor: "#000000", // Black (headings)
      borderColor: "#e1e8ed", // Light gray border
      pinkColor: "#FAFBFC", // Light background
      disabledColor: "#d0d0d0", // Disabled/greyed-out state
      infoBoxBg: "#E3F2FD", // Light blue info box background (YCM brand color)
      infoBoxText: "#000000", // Black text
      alertBoxBg: "#e67e22", // Orange alert box (uses secondary)
      lenderBlockBg: "#ffe8d6", // Light peach lender block
      successColor: "#ff914d", // Orange for success actions
      darkBg: "#3A4F66", // Dark slate blue background
      inputBorder: "#000000", // Black border for inputs
      lightBorder: "#e1e8ed", // Light border
      whiteBg: "#ffffff", // White background
      offWhiteBg: "#fff", // Off-white background
      lightGrayBorder: "#e1e8ed", // Light gray border
      mediumGray: "#999", // Medium gray
      darkGray: "#666", // Dark gray
      textDark: "#000000", // Black text
      hoverGray: "#fff0e6", // Light orange hover
    },

    logo: "/logos/ycm-logo.svg",
    favicon: "/logos/ycm-favicon.svg",
    font: "'Raleway', sans-serif",
    rating: 4.4,

    meta: {
      title: "Your Claim Matters - Car Finance Claims",
      description: "Make your car finance claim with Your Claim Matters",
    },
  },

  [BRAND_IDS.MLM]: {
    id: BRAND_IDS.MLM,
    name: "MLM",
    displayName: "MLM",
    domains: ["app.mlmcarfinanceclaims.co.uk", "mlmcarfinanceclaims.co.uk"],
    email: "info@mylawmatters.co.uk",
    supportEmail: "support.email@mylawmatters.co.uk",

    reviewUrls: {
      customerReview: "https://mylawmatters.co.uk/customer-review",
      google: "https://g.page/r/MLM/review",
      trustpilot: "https://www.trustpilot.com/evaluate/mylawmatters.co.uk",
    },

    // Probability for "Good" and "Excellent" ratings to route to Google vs Trustpilot
    reviewProbabilities: {
      google: 0.7, // 70% chance to use Google
      trustpilot: 0.3, // 30% chance to use Trustpilot
    },

    // MLM has multiple color variations - active variation determined by MLM_ACTIVE_VARIATION
    variations: {
      1: {
        // Original MLM colors (black/indigo/yellow)
        logo: "/logos/mlm-logo.svg",
        favicon: "/logos/mlm-favicon.svg",
        primary: "#000000",
        secondary: "#1e1b4b",
        accent: "#eab308",
        brandColor: "#eab308",
        brandButtonText: "#000000",
        currentColor: "#000000",
        altFontColor: "#ffffff",
        grayBg: "rgba(99, 136, 198, 0.05)",
        lightGrayBg: "#F7F7F7",
        extraLightGrayBg: "#F3F4F4",
        grayColor: "#171717",
        borderColor: "#dddddd",
        pinkColor: "#FEF3EF",
        disabledColor: "#BFCDCD",
        infoBoxBg: "#bfdbfe",
        infoBoxText: "#042020",
        alertBoxBg: "#002020",
        lenderBlockBg: "#bfdbfe",
        successColor: "#1e1b4b",
        darkBg: "#001A42",
        inputBorder: "#707070",
        lightBorder: "#ccc",
        whiteBg: "#ffffff",
        offWhiteBg: "#fff",
        lightGrayBorder: "#ddd",
        mediumGray: "#999",
        darkGray: "#666",
        textDark: "#333",
        hoverGray: "#f5f5f5",
      },
      2: {
        // New MLM variation 2 (red/pink/blue)
        logo: "/logos/mlm-logo-v2.png",
        favicon: "/logos/mlm-favicon-v2.svg",
        primary: "#BB0000",
        secondary: "#F8E5E5",
        accent: "#BB0000",
        brandColor: "#BB0000",
        brandButtonText: "#ffffff",
        currentColor: "#000000",
        altFontColor: "#ffffff",
        grayBg: "#FDF5F5",
        lightGrayBg: "#f8f9fa",
        extraLightGrayBg: "#fefefe",
        grayColor: "#000000",
        borderColor: "#BB0000",
        pinkColor: "#F8E5E5",
        disabledColor: "#dee2e6",
        infoBoxBg: "#F8E5E5",
        infoBoxText: "#000000",
        alertBoxBg: "#fff3cd",
        lenderBlockBg: "#FDF5F5",
        successColor: "#BB0000",
        darkBg: "#133d6a",
        inputBorder: "#ced4da",
        lightBorder: "#e0e0e0",
        whiteBg: "#ffffff",
        offWhiteBg: "#f9f9f9",
        lightGrayBorder: "#dee2e6",
        mediumGray: "#999999",
        darkGray: "#666666",
        textDark: "#333333",
        hoverGray: "#F8E5E5",
      },
    },

    // Get colors from active variation
    get colors() {
      return this.variations[MLM_ACTIVE_VARIATION];
    },

    // Get logo from active variation
    get logo() {
      return this.variations[MLM_ACTIVE_VARIATION].logo;
    },

    // Get favicon from active variation
    get favicon() {
      return this.variations[MLM_ACTIVE_VARIATION].favicon;
    },
    font: "'Raleway', sans-serif",
    rating: 4.6,

    meta: {
      title: "MLM - Car Finance Claims",
      description: "Make your car finance claim with My Law Matters",
    },
  },
};

// CSS Variable Mappings
export const CSS_VARIABLES = {
  "--theme-color-1": "primary",
  "--theme-color-2": "secondary",
  "--theme-color-3": "accent",
  "--ycm-orange": "brandColor",
  "--brand-button-text": "brandButtonText",
  "--current-color": "currentColor",
  "--alt-font-color": "altFontColor",
  "--gray-bg": "grayBg",
  "--light-gray-bg": "lightGrayBg",
  "--extra-light-gray-bg": "extraLightGrayBg",
  "--gray-color": "grayColor",
  "--border-color": "borderColor",
  "--pink-color": "pinkColor",
  "--disabled-color": "disabledColor",
  "--info-box-bg": "infoBoxBg",
  "--brand-info-bg": "infoBoxBg",
  "--info-box-text": "infoBoxText",
  "--alert-box-bg": "alertBoxBg",
  "--lender-block-bg": "lenderBlockBg",
  "--success-color": "successColor",
  "--dark-bg": "darkBg",
  "--input-border": "inputBorder",
  "--light-border": "lightBorder",
  "--white-bg": "whiteBg",
  "--off-white-bg": "offWhiteBg",
  "--light-gray-border": "lightGrayBorder",
  "--medium-gray": "mediumGray",
  "--dark-gray": "darkGray",
  "--text-dark": "textDark",
  "--hover-gray": "hoverGray",
  "--current-font": "font",
};

// Default brand (fallback)
export const DEFAULT_BRAND = BRANDS[BRAND_IDS.CLAIM1];
